// src/components/SetupRequired.jsx
import React from 'react';
import { AlertCircle, CheckCircle, XCircle } from 'lucide-react';
import styles from './SetupRequired.module.css';

export default function SetupRequired() {
  const supabaseConfigured = !!(import.meta.env.VITE_SUPABASE_URL && import.meta.env.VITE_SUPABASE_ANON_KEY);
  const googleConfigured = !!import.meta.env.VITE_GOOGLE_CLIENT_ID;

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.iconBadge}>
            <AlertCircle size={32} aria-hidden="true" />
          </div>
          <h1 className={styles.title}>Setup Required</h1>
          <p className={styles.subtitle}>Vennio needs to be configured before you can use it.</p>
        </div>

        <div className={styles.items}>
          <div className={styles.item}>
            {supabaseConfigured
              ? <CheckCircle className={styles.itemOk} size={20} />
              : <XCircle    className={styles.itemErr} size={20} />}
            <div>
              <h3 className={styles.itemTitle}>Supabase Configuration</h3>
              <p className={styles.itemDesc}>
                {supabaseConfigured
                  ? 'Configured ✓'
                  : 'Missing VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY'}
              </p>
            </div>
          </div>

          <div className={styles.item}>
            {googleConfigured
              ? <CheckCircle className={styles.itemOk} size={20} />
              : <XCircle    className={styles.itemErr} size={20} />}
            <div>
              <h3 className={styles.itemTitle}>Google Calendar API</h3>
              <p className={styles.itemDesc}>
                {googleConfigured
                  ? 'Configured ✓'
                  : 'Missing VITE_GOOGLE_CLIENT_ID'}
              </p>
            </div>
          </div>
        </div>

        <div className={styles.infoBox}>
          <h3 className={styles.infoBox__title}>Quick Setup (30 minutes)</h3>
          <ol className={styles.infoBox__list}>
            <li>Create a Supabase account and project</li>
            <li>Set up Google Calendar API credentials</li>
            <li>Create <code className={styles.inlineCode}>.env.local</code> file in project root</li>
            <li>Add your credentials to the file</li>
            <li>Refresh this page</li>
          </ol>
        </div>

        <div className={styles.actions}>
          <a
            href="https://github.com/your-repo/blob/main/QUICK_START.md"
            target="_blank"
            rel="noopener noreferrer"
            className={`btn-primary ${styles.btnPrimary}`}
          >
            📖 Read Quick Start Guide
          </a>

          <details className={styles.details}>
            <summary>Show .env.local template</summary>
            <pre className={styles.codeBlock}>
{`# Supabase
VITE_SUPABASE_URL=https://your-project.supabase.co
VITE_SUPABASE_ANON_KEY=your-anon-key-here

# Google Calendar API
VITE_GOOGLE_CLIENT_ID=your-client-id.apps.googleusercontent.com

# App URL
VITE_APP_URL=http://localhost:5173`}
            </pre>
          </details>
        </div>

        <p className={styles.help}>Need help? Check the console for detailed error messages.</p>
      </div>
    </div>
  );
}
